import React, { useEffect } from "react";

const GNX2Script = ({ inBlogAdsList = [] }) => {

  const addedAssets = inBlogAdsList.map((item, index) => ({
    url: `/blog/${item.blogAdsLink?.en?.split("/blog/")[1] || "default-slug"}`,
    product: item.productCategory?.en?.toLowerCase().replace(/\s/g, "-") || "",
    title: item.title?.en || "Untitled Product",
    link: item.productAdsLink?.en || "#",
    image: item.productAdsImage?.url || "",
  }));
  useEffect(() => {
    if (typeof window === "undefined") return;

    console.log("GNX2 - V1");

    function addStyle(styleString) {
      const style = document.createElement("style");
      style.textContent = styleString;
      document.head.append(style);
      style.id = "GNX2";
    }

    if (!document.querySelector("#gnx2")) {
      addStyle(`
        .rich-text--blog h3.headline {
          color: #000;
          font-family: "Galaxie";
          font-size: 27px;
          font-style: normal;
          font-weight: 500;
          text-align: center;
          letter-spacing: normal;
          margin: 0; 
          line-height: 40px; 
          text-align: center !important;
          padding-top: 20px;
        }
        
        @media (min-width: 1024px) {
          // .rich-text--blog h3.headline {
          //   text-align: left !important;
          // }
        }
        
        .ad-container {
          margin-block: 2rem;
          border-radius: 15px;
        }
        
        .ad-container.cold-flu {
          background-color: #B5C6ED;
        }
        
        .ad-container.pain-fever {
          background: #B5C6ED;
        }

        .ad-container.extra-strength {
          background-color: #FDCFD2;
        }
        
        .ad-container.tummy {
          background-color: #C5E0F5;
        }
          .text-and-button-container {
          text-align:center !important;
          }
          .ad-anchor {
            background: white;
            padding: 12px 30px;
            border-radius: 50px;
            border-bottom: 0 !important;
            display: inline-block;
            color: #6077c1;
            text-transform: uppercase;
            margin: 20px auto;
          }
      `);
    }

    const testFired = () => {
        window.gnx2testfired = true; // Set the flag to true
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "GA4event",
          "ga4-event-name": "cro_event",
          "ga4-event-p1-name": "event_category",
          "ga4-event-p1-value": "GNX2_Test_Fired",
          "ga4-event-p2-name": "event_label",
          "ga4-event-p2-value": "test fired variant 1",
        });
      };

      const watcher = new IntersectionObserver(entries => {
        entries.forEach(entry => {
        const intersecting = entry.isIntersecting
        if (intersecting) {
           window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
        event: "GA4event",
        "ga4-event-name": 'cro_event',
        "ga4-event-p1-name": 'event_category',
        "ga4-event-p1-value": 'GNX2_ScrolledToSection',
        });
        }
        })
        //console.log(window.dataLayer)
      })
      
    
    
    const deployIO = (blogContainer) => {
      const adContainer = blogContainer.querySelector('.ad-container')
      watcher.observe(adContainer)
    
    }

    const givenAssets = [
        { url: '/blog/how-to-unblock-your-nose-instantly', product: "cold-flu", title: "Daytime Cough + Nighttime Severe Cold & Flu Combo Pack", link: "https://www.genexa.com/products/daytime-cough-nighttime-severe-cold-flu-combo-pack", image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_58_2.png?v=1740080781' },
        { url: '/blog/acetaminophen-for-children-dosage', product: "pain-fever", title: "Kids' Pain & Fever Blueberry Flavor", link: 'https://www.genexa.com/products/kids-pain-fever-acetaminophen-liquid', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_62.png?v=1740176709' },
        { url: '/blog/can-your-child-take-antacids-for-digestive-issues', product: "tummy", title: "Genexa Kids’ Clean Tummy Relief Antacid Chewables", link: 'https://www.genexa.com/products/kids-tummy-relief', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_59.png?v=1740084313' },
        { url: '/blog/can-colds-cause-dizziness', product: "cold-flu", title: "Daytime Cough + Nighttime Severe Cold & Flu Combo Pack", link: 'https://www.genexa.com/products/daytime-cough-nighttime-severe-cold-flu-combo-pack', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_58_2.png?v=1740080781' },
        { url: '/blog/how-to-get-rid-of-a-headache-after-crying', product: "extra-strength", title: "Acetaminophen <br> Extra Strength 50ct", link: 'https://www.genexa.com/products/acetaminophen-extra-strength-50ct', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_61.png?v=1740084697' },
        { url: '/blog/how-to-treat-a-headache-at-the-base-of-your-skull', product: "extra-strength", title: "Acetaminophen Extra Strength 50ct", link: 'https://www.genexa.com/products/acetaminophen-extra-strength-50ct', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_61.png?v=1740084697' },
        { url: '/blog/how-to-relieve-chest-tightness', product: "cold-flu", title: "Daytime Cough + Nighttime Severe Cold & Flu Combo Pack", link: 'https://www.genexa.com/products/daytime-cough-nighttime-severe-cold-flu-combo-pack', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_58_2.png?v=1740080781' },
        { url: '/blog/how-to-treat-body-aches-caused-by-flu-or-sickness', product: "cold-flu", title: "Daytime Cough + Nighttime Severe Cold & Flu Combo Pack", link: 'https://www.genexa.com/products/daytime-cough-nighttime-severe-cold-flu-combo-pack', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_58_2.png?v=1740080781' },
        { url: '/blog/how-to-treat-chills-in-yourself-or-your-child',  product: "pain-fever", title: "Kids' Pain & Fever Blueberry Flavor", link: 'https://www.genexa.com/products/kids-pain-fever-acetaminophen-liquid', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_62.png?v=1740176709' },
        { url: '/blog/nasal-spray-side-effects', product: "cold-flu", title: "Daytime Cough + Nighttime Severe Cold & Flu Combo Pack", link: 'https://www.genexa.com/products/daytime-cough-nighttime-severe-cold-flu-combo-pack', image: 'https://cdn.shopify.com/s/files/1/0612/5086/3345/files/Group_58_2.png?v=1740080781' },
        ];
        
        const assets = [...givenAssets, ...addedAssets];


    //const result = Object.groupBy(assets, ({ url }) => url);

const fireTest = assets.some(ass => ass.url === window.location.pathname);

fireTest && testFired();


if (window.gnx2testfired) {
const findThirdwayElement = setInterval(() => {
  const blogContainer = document.querySelector('.rich-text--blog div')

  if (blogContainer) {
    clearInterval(findThirdwayElement);
    injectThirdway(blogContainer);
      // need intersection observer
    deployIO(blogContainer);
  }
}, 100);
}

function injectThirdway(blogContainer) {
    const scrollHeight = blogContainer.scrollHeight;
    const thirdwayPosition = scrollHeight / 3;
    
    const allNodes = blogContainer.querySelectorAll('*');
    
    //window.scrollTo(0, thirdwayPosition)
    
    for (const node of allNodes) {
      if (node.offsetTop > thirdwayPosition) {
       injectMarkup(node)
        return node;
      }
    }
    }
    

    const currentPath = window.location.pathname;
    const specificAsset = [...assets].reverse().find(asset => asset.url === currentPath);

    if (!specificAsset) return;

    const blogContainer = document.querySelector(".rich-text--blog");

    if (!blogContainer) return;

    const injectMarkup = (node) => {
        //console.log('inject markup function', node)
        const adMarkup = 
        `
        <div class="ad-container ${specificAsset.product}">
        <div class="ad-wrapper">
        <div class="text-and-button-container">
        <h3 class="headline">${specificAsset.title}</h3>
        <a class="ad-anchor" href="${specificAsset.link}">Where to Buy</a>
        </div>
        <div class="image-wrapper">
        <img class="ad-image" src="${specificAsset.image}">
        </div>
        </div>
        </div>
        
        `        
        if (!document.querySelector('.ad-container')) {
        node.insertAdjacentHTML('afterend', adMarkup)
        document.querySelector('.ad-anchor').addEventListener('click', ()=> {
          window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
            event: "GA4event",
            "ga4-event-name": 'cro_event',
            "ga4-event-p1-name": 'event_category',
            "ga4-event-p1-value": 'GNX2_CTAEngagement',
            });
        
        })
        }
        }
  }, []);

  return null;
};

export default GNX2Script;
